import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Users from "components/users/Users";
import { initialMetaForTable } from "constants/common";
import { revokeAuthToken } from "containers/login/api";
import { isEmpty } from "lodash";
import { removeAccessToken, removeUserInfoFromStorage } from "utils/common";
import { LOGIN_PATH } from "constants/routePaths";

const Index = () => {
  const [userType, setUserType] = useState("program_coordinator");
  const [meta, setMeta] = useState(initialMetaForTable);

  const navigate = useNavigate();

  const logoutHandler = async () => {
    try {
      const res = await revokeAuthToken();
      if (isEmpty(res)) {
        removeAccessToken();
        removeUserInfoFromStorage();
        navigate(LOGIN_PATH);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const userTypes = [
    { key: "program_coordinator", label: "Program Coordinator" },
    { key: "housing_navigator", label: "Housing Navigator" },
    { key: "case_manager", label: "CSS Manager" },
    { key: "executive", label: "Executive" },
    { key: "accounting", label: "Accounting" },
  ];

  return (
    <div className="main-contents">
      <h1>Users</h1>
      <div className="d-flex flex-wrap gap-2 ms-3">
        {userTypes.map(({ key, label }) => (
          <button
            key={key}
            className={`w-max ${
              userType === key ? "primary-btn" : "secondary-btn"
            }`}
            onClick={() => {
              setUserType(key);
              setMeta(initialMetaForTable);
            }}
          >
            {label}
          </button>
        ))}
      </div>
      <Users
        userType={userType}
        meta={meta}
        setMeta={setMeta}
        logoutHandler={logoutHandler}
      />
    </div>
  );
};

export default Index;
